import React from "react"
import { formatDate, FormatDateFormat } from "../app-core/_common/format/date"

interface DateOnlyFormatProps {
    value: Date | string | undefined
    format: FormatDateFormat
}

const DateOnlyFormat: React.FC<React.PropsWithChildren<DateOnlyFormatProps>> = ({ value, format }) => {
    if (!value) return null
    return <React.Fragment>{formatDate(value, format)}</React.Fragment>
}

export default DateOnlyFormat
